import React from 'react'
import ImmutablePropTypes from 'react-immutable-proptypes'
import exact from 'prop-types-exact'
import { useSelector, useDispatch, useStore } from 'react-redux'
import NewsListBoxItems from './NewsListBoxItems'
import { itemIdsToItems } from '../item/itemsTransformers'
import { MIN_POPULAR_CLICKS } from './SidebarPopular'
import './newsListBox.pcss'

const PopularNewsListBox = ({ category, tag }) => {
  const dispatch = useDispatch()
  const itemIds = useSelector(state => state.popular.get('itemIds'))
  const loading = useSelector(state => state.popular.get('loading'))
  const failedToLoad = useSelector(state => state.popular.get('failedToLoad'))

  // Using store.getState() to avoid re-rendering on every tiny change in the state
  const state = useStore().getState()
  const items = itemIdsToItems(state, itemIds)

  // Note that we intentionally don't have any autorefresh logic here. SidebarPopular
  // is also mounted, even though invisible due to responsice CSS, and it will take
  // care of the periodic refreshing.

  if (items.size < 5 || items.last().get('clicks', 0) < MIN_POPULAR_CLICKS) {
    return null
  }

  let title = 'Luetuimpia'
  if (category) {
    title = 'Luetuimpia: ' + category.get('name')
  }
  if (tag) {
    title = 'Luetuimpia: #' + tag.get('name')
  }

  return (
    <NewsListBoxItems
      title={ title }
      linkTo='/luetuimmat'
      linkToTitle='Kaikki luetuimmat'
      className='popular'
      dispatch={ dispatch }
      loading={ loading }
      failedToLoad={ failedToLoad }
      items={ items }
      emptyText=''
    />
  )
}

PopularNewsListBox.propTypes = exact({
  category: ImmutablePropTypes.record,
  tag: ImmutablePropTypes.record,
})

export default PopularNewsListBox
